var _a;
import { createSlice } from '@reduxjs/toolkit';
import * as reducers from './reducers';
import { buildInitialState } from './initial-state';
var activeCampaignSlice = createSlice({
    name: 'activeCampaign',
    initialState: buildInitialState(),
    reducers: reducers,
});
export var reducer = activeCampaignSlice.reducer, setEditableFieldValue = (_a = activeCampaignSlice.actions, _a.setEditableFieldValue), resetFieldsToInitialState = _a.resetFieldsToInitialState, setInitStatus = _a.setInitStatus, populateFieldsFromApiCampaign = _a.populateFieldsFromApiCampaign, setEditableFieldError = _a.setEditableFieldError, clearEditableFieldError = _a.clearEditableFieldError, clearAllEditableFieldErrors = _a.clearAllEditableFieldErrors, resetCampaign = _a.resetCampaign, setIsProcessing = _a.setIsProcessing, setMetadata = _a.setMetadata;
